import {
  AddArrowAction,
  IArrow,
  IConnection,
  IDatasetState,
  ISelectedTable,
  LoadAction,
  RemoveArrowAction,
  ResetAction,
  SelectConnectionAction,
  SetDatasetNameAction,
  SetIsExtractAction,
  SetSelectedTablesAction,
  UpdateAllArrowsInRelation as _UpdateAllArrowsInRelation,
  UpdateConnectionsAction,
  UpdateDBAction,
  UpdateSchemaAction,
} from './types';

export function LoadState(state: IDatasetState): LoadAction {
  return {
    type: 'LOAD',
    payload: state,
  };
}
export function ResetDatasetState(): ResetAction {
  return {
    type: 'RESET',
  };
}
export function UpdateConnections(connections: IConnection[]): UpdateConnectionsAction {
  return {
    type: 'UPDATE_CONNECTIONS',
    payload: connections,
  };
}
export function UpdateDB(connectionId: string, db: string): UpdateDBAction {
  return {
    type: 'UPDATE_DB',
    payload: {
      connectionId,
      db,
    },
  };
}
export function UpdateSchema(connectionId: string, schema: string): UpdateSchemaAction {
  return {
    type: 'UPDATE_SCHEMA',
    payload: {
      connectionId,
      schema,
    },
  };
}
export function SelectConnection(connectionId: string): SelectConnectionAction {
  return {
    type: 'SELECT_CONNECTION',
    payload: connectionId,
  };
}
export function SetSelectedTables(tables: ISelectedTable[]): SetSelectedTablesAction {
  return {
    type: 'SET_SELECTED_TABLES',
    payload: tables,
  };
}
export function SetIsExtract(val: boolean): SetIsExtractAction {
  return {
    type: 'SET_IS_EXTRACT',
    payload: val,
  };
}
export function AddArrow(arrow: IArrow): AddArrowAction {
  return {
    type: 'ADD_ARROWS',
    payload: arrow,
  };
}
export function RemoveArrow(arrowId: string | string[]): RemoveArrowAction {
  return {
    type: 'REMOVE_ARROW',
    payload: Array.isArray(arrowId) ? arrowId : [arrowId],
  };
}
// export function AddRelation(relation: IRelationship): AddRelationAction {
//   return {
//     type: 'ADD_RELATION',
//     payload: relation,
//   };
// }
// export function RemoveRelation(relationId: string | number): RemoveRelationAction {
//   return {
//     type: 'REMOVE_RELATION',
//     payload: relationId,
//   };
// }

export function SetDatasetName(name: string): SetDatasetNameAction {
  return {
    type: 'SET_DATASET_NAME',
    payload: name,
  };
}

export function UpdateAllArrowsInRelation(
  relationId: string,
  cardinality: string,
  integrity: string,
  showHead: boolean,
  showTail: boolean,
  startTableId : string,
  endTableId : string
): _UpdateAllArrowsInRelation {
  return {
    type: 'UPDATE_ALL_ARROWSIN_RELATION',
    payload: {
      relationId,
      cardinality,
      integrity,
      showHead,
      showTail,
      startTableId,
      endTableId
    },
  };
}

export function duplicateTable(tableId: string, newId: string, alias : string){
  return {
    type : "DUPLICATE_TABLE",
    payload: { tableId, newId, alias }
  }
}
